
<div class="main-div">
 <div class="review-section">
     <p class="review-heading">Review enrollment settings</p>
     <br>
     <div class="review-info">
         <div class="first-block review-blocks">
             <p class="review-block-heading">Foundation account</p>
             <p class="review-block-value" *ngFor="let fan of signupArray">{{fan}}</p>
         </div>
         <div class="second-block review-blocks" >
             <p class="review-block-heading">Google ID</p>
             <p class="review-block-value" *ngFor="let fan of signupArray">1923415519</p>
         </div>
         <!-- <div class="second-block review-blocks" *ngIf="abm">
             <p class="review-block-heading">{{reviewSignupSetup.productId2}}</p>
             <p class="review-block-value" *ngFor="let fan of signupArray">{{proddets.selectedAccID}}</p>
         </div>
         <div class="second-block review-blocks" *ngIf="kme">
             <p class="review-block-heading">{{reviewSignupSetup.productId3}}</p>
             <p class="review-block-value" *ngFor="let fan of signupArray">{{proddets.selectedAccID}}</p>
         </div> -->
         <div class="third-block review-blocks">
             <label><span class="inline-labels"></span>
                 <div class="tooltip-input inline-labels">
                     <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
                       aria-label="Help"></i>
                     <!-- <div role="tooltip" class="helper-text" id="inputhelp">
                         {{reviewSignupSetup.existingDevicesTooltip}}</div> -->
                 </div>
             </label>
             <p class="review-block-heading">Existing devices</p>
             <p class="review-block-value" *ngFor="let fan of signupArray">Do Not Enroll</p>
         </div>
         <!-- <div class="fourth-block review-blocks">
             <div class="review-block-heading">
                 <div class="tooltip-input inline-labels">
                     <i class="icon-flat-faq tooltip-icon" tabindex="0" aria-describedby="inputhelp"
                         (keypress)="toggleTooltip($event)" (click)="toggleTooltip($event)" aria-label="Help"></i>
                     <div role="tooltip" class="helper-text" id="inputhelp">
                         {{reviewSignupSetup.existingDevicesTooltip}}</div>
                 </div>
             </div>
         </div> -->
     </div>
     <br>
 </div>
 <br>
 <hr>
 <div class="product-section">
     <p class="product-heading"><strong>Device management solution</strong></p>
     <p class="product-fields prod-field"><strong>You're using: Android Zero-touch</strong> </p>
 </div>
 <br>

 <div class="acknowledgement-section">
     <div class="acknowledgement-sub-section">
         <p class="acknowledgement-heading">Acknowledgement
         </p>
         <p class="acknowledgement-description">The selected settings will be deployed for all devices associated with the foundation accounts selected.


         </p>
         <div class="confirm-section">
             <label class="checkbox" for="confirmSubmission">
                 <input aria-describedby="confirmSubmit" #confirm type="checkbox" id="confirmSubmission"
                     aria-label="Confirm Submission" name="Confirm Submission" (click)="enableSubmit()" >
                 <i class="skin"></i>
                 <span id="confirmSubmit"> I understand </span>
             </label>
         </div>
     </div>
 </div> <br>
 <div class="submit-section">
     <button class="btn btn-secondary labels-inline" id="finishEnrollment" [disabled]="isDisabled"
         >Finish Enrollment</button>
     <a id="cancel-link"  
         class="labels-inline">Cancel</a>
 </div><br>
</div>